import { data } from "autoprefixer";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state/index";
import { Button, Pagination } from "antd";
import { serverAddress } from "../../constant";
import { notify_error } from "../Notify";
import TableSkeleton from "../skeletons/TableSkeleton";


const MootCompetitionTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { top_loader } = bindActionCreators(actionCreators, dispatch);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [recperpage, SetRecPerPage] = useState(25);
  const [activepage, SetActivePage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [paymentFilter, setPaymentFilter] = useState("All");

  const handleRowClick = (student) => {
    setSelectedEvents(student.events || []);
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    top_loader(true, 45);
    getAllMootCompetition({ page: activepage, limit: recperpage });
  }, []);
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      .custom-sidebar::-webkit-scrollbar { display: none; }
      .custom-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const getAllMootCompetition = async(params) => {
    setLoading(true);
    const response = await fetch(`${serverAddress}/court_competition/get/all?page=${params?.page}&limit=${params?.limit}`);
    const result = await response.json();
    setData(result.data)
    setTotalData(result.total);
    setLoading(false);
    top_loader(true, 100);
    top_loader(false, 0);
  };
  useEffect(() => { 
    console.log("Data", data);
  }, [data]);

  function handlePageChange(page) {
    SetActivePage(page);
    getAllMootCompetition({ page: page, limit: recperpage });
  }

  function applyFilter(event) {
    SetRecPerPage(event.target.value);
    getAllMootCompetition({ page: 1, limit: event.target.value });
    SetActivePage(1);
  }

  async function handleDownloadButtonClick() {
    try {
      if (!data || !Array.isArray(data) || data.length === 0) {
        notify_error("No data found to download.");
        return;
      }
      const csvContent = convertJsonToCsv(data);
      const blob = new Blob([csvContent], { type: "text/csv" });
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = URL.createObjectURL(blob);
      a.download = "moot_competition_students.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      notify_error("Error generating or downloading data:", error);
    }
  }
  
  const filteredData = data
    .filter((item) => {
      const matchesSearch =
        searchText === "" ||
        (item.institutionName || "").toLowerCase().includes(searchText.toLowerCase()) ||
        (item.researcherName || "").toLowerCase().includes(searchText.toLowerCase()) ||
        (item.facultyName || "").toLowerCase().includes(searchText.toLowerCase()) ||
        (item.speaker1Name || "").toLowerCase().includes(searchText.toLowerCase()) ||
        (item.speaker2Name || "").toLowerCase().includes(searchText.toLowerCase());
      const matchesPayment =
        paymentFilter === "All" ||
        (paymentFilter === "Paid" && item.paymentStatus === "Paid") ||
        (paymentFilter === "Pending" && item.paymentStatus !== "Paid");
      return matchesSearch && matchesPayment;
    })
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

  function convertJsonToCsv(data) {
    if (!data || data.length === 0) return '';
    // Collect all unique keys from all objects
    const allKeys = Array.from(new Set(data.flatMap(obj => Object.keys(obj))));
    const headers = allKeys;
    const rows = data.map((row) =>
      headers.map((field) => `"${(row[field] ?? "").toString().replace(/"/g, '""')}"`).join(",")
    );
    return [headers.join(","), ...rows].join("\n");
  }

  return (
    <Container
      fluid
      className="p-0 custom-sidebar"
      style={{
        backgroundColor: "#F2F5F7",
        fontFamily: "Inter",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <Row style={{ marginInline: "10px" }}>
        <Col lg={12}>
          <div className="py-2" style={{ marginTop: "80px" }}>

            {/* Header Card */}
            <div
              className="bg-white rounded shadow-sm mb-3 px-4 py-3"
              style={{ borderLeft: "4px solid #663399" }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div>
                  <h5 style={{ margin: 0, fontWeight: "700", color: "#1a1a2e", fontSize: "18px", letterSpacing: "0.3px" }}>
                    Moot Court Competition Registrations
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  {/* Search */}
                  <div style={{ position: "relative" }}>
                    <i
                      className="fa-solid fa-magnifying-glass"
                      style={{
                        position: "absolute",
                        left: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#aaa",
                        fontSize: "13px",
                      }}
                    />
                    <input
                      type="text"
                      placeholder="Search by name, institution..."
                      value={searchText}
                      onChange={(e) => { setSearchText(e.target.value); SetActivePage(1); }}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "7px 12px 7px 32px",
                        height: "38px",
                        fontSize: "13px",
                        width: "260px",
                        outline: "none",
                        fontFamily: "Inter",
                        backgroundColor: "#fafafa",
                      }}
                    />
                  </div>
                  {/* Payment Filter */}
                  <Form.Select
                    value={paymentFilter}
                    onChange={(e) => { setPaymentFilter(e.target.value); SetActivePage(1); }}
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      height: "38px",
                      fontSize: "13px",
                      width: "155px",
                      color: "#333",
                      fontFamily: "Inter",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <option value="All">All Payments</option>
                    <option value="Paid">Paid</option>
                    <option value="Failed">Pending</option>
                  </Form.Select>
                  {/* Export */}
                  <button
                    onClick={() => handleDownloadButtonClick()}
                    style={{
                      backgroundColor: "#663399",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "7px 16px",
                      height: "38px",
                      fontSize: "13px",
                      fontFamily: "Inter",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <i className="fa-solid fa-download" style={{ fontSize: "12px" }} />
                    Export CSV
                  </button>
                </div>
              </div>
            </div>

            {/* Table Card */}
            <div className="bg-white rounded shadow-sm" style={{ overflow: "hidden" }}>
              <div
                className="maintable"
                id="table-container"
                style={{ overflowX: "auto" }}
              >
                {loading ? (
                  <TableSkeleton />
                ) : (
                  <table
                    className="col-md-12 enquiryTable px-3"
                    style={{ tableLayout: "fixed", width: "100%", marginBottom: 0 }}
                  >
                    <thead className="bg-transparent">
                      <tr className="tableHeading tableHeadAllEnquiry bg-transparent">
                        <th style={{ width: "60px" }}>S.No.</th>
                        <th style={{ width: "200px" }}>Institution Name</th>
                        <th style={{ width: "160px" }}>Researcher Name</th>
                        <th style={{ width: "160px" }}>Faculty Name</th>
                        <th style={{ width: "160px" }}>Speaker 1 Name</th>
                        <th style={{ width: "160px" }}>Speaker 2 Name</th>
                        <th style={{ width: "130px" }}>Payment Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                          <tr
                            key={item._id}
                            className="tableRows"
                            onClick={() => navigate(`/dashboard/moot-competition-registration/${item._id}`)}
                          >
                            <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "#888", fontSize: "13px" }}>
                              {(activepage - 1) * recperpage + index + 1}
                            </td>
                            <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: "600", color: "#1a1a2e" }}>
                              {item.institutionName || "—"}
                            </td>
                            <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {item.researcherName || "—"}
                            </td>
                            <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {item.facultyName || "—"}
                            </td>
                            <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {item.speaker1Name || "—"}
                            </td>
                            <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {item.speaker2Name || "—"}
                            </td>
                            <td>
                              <span style={{
                                border: item.paymentStatus === "Paid" ? "1px solid #CAEEDB" : "1px solid #FFE3E0",
                                backgroundColor: item.paymentStatus === "Paid" ? "#CAEEDB" : "#FFE3E0",
                                color: item.paymentStatus === "Paid" ? "#46CF85" : "#F7685B",
                                padding: "3px 10px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}>
                                {item.paymentStatus === "Paid" ? "Paid" : (item.paymentStatus || "Unpaid")}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center", padding: "40px", color: "#999", fontSize: "14px" }}>
                            <i className="fa-solid fa-inbox me-2" style={{ fontSize: "20px" }} />
                            <br />No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Footer */}
              <div
                className="col-md-12 form-inline py-2 tableFooter d-flex gap-5 align-items-center"
                style={{ borderTop: "1px solid #f0f0f0" }}
              >
                <div className="col-md-4 d-flex gap-2 align-baseline">
                  <label
                    className="control-label col-md-4"
                    style={{ fontWeight: "700", paddingTop: "5px", paddingLeft: "25px" }}
                  >
                    Rows per page :
                  </label>
                  <Form.Select
                    className="form-control"
                    onChange={(event) => applyFilter(event)}
                    value={recperpage}
                    style={{ border: "solid", borderWidth: "thin", color: "#000" }}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </Form.Select>
                </div>
                <div
                  className="col-md-8 d-flex gap-2"
                  style={{ justifyContent: "end", alignItems: "center", paddingRight: "60px" }}
                >
                  <Pagination
                    total={totalData}
                    showSizeChanger={false}
                    current={activepage}
                    size="small"
                    pageSize={recperpage}
                    onChange={(page) => handlePageChange(page)}
                  />
                </div>
              </div>
            </div>

          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MootCompetitionTable; 